export default {
  showMenu: false,
  snackbar: false,
  snackbarSuccess: true,
  snackbarMessage: "",
  currentUser: {},
  menu: [
    {
      icon: "mdi-pin",
      title: "Партнёры",
      link: "/partners",
      image: "https://picsum.photos/200/300?random=1",
      types: ["manager", "sv", "admin"]
    },
    {
      icon: "mdi-help",
      title: "Инструкция для партнёров",
      link: "/api-manual",
      image: "https://picsum.photos/200/300?random=2",
      types: ["manager", "sv", "admin"]
    },
    {
      icon: "mdi-account",
      title: "Пользователи",
      link: "/users",
      image: "https://picsum.photos/200/300?random=3",
      types: ["sv", "admin"]
    },
    {
      icon: "mdi-wrench",
      title: "Настройки",
      link: "/settings",
      image: "https://picsum.photos/200/300?random=4",
      types: ["sv", "admin"]
    },
    {
      icon: "mdi-file",
      title: "Лог загрузок",
      link: "/log",
      image: "https://picsum.photos/200/300?random=5",
      types: ["sv", "admin"]
    },
    {
      icon: "mdi-map-search-outline",
      title: "Демо карты воды",
      link: "/demo",
      image: "https://picsum.photos/200/300?random=6",
      types: ["sv", "manager", "admin"]
    }
  ],
  usertypes: []
};
